import { render, staticRenderFns } from "./wipay-ticket.vue?vue&type=template&id=7c8d02fe&scoped=true&"
import script from "./wipay-ticket.ts?vue&type=script&lang=ts&"
export * from "./wipay-ticket.ts?vue&type=script&lang=ts&"
import style0 from "./wipay-ticket.scss?vue&type=style&index=0&id=7c8d02fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d02fe",
  null
  
)

export default component.exports